<template>
    <main-content>
        <kt-panel>
            <kt-panel-body>
                <ivr-form :form_data="form_data" :submit="submit" v-if="status !== 'loading'"></ivr-form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import IVRForm from './components/form'
import $ from 'jquery'
import {KTApp} from '@/plugins/core/app'
import {ivrService} from '@/common/api.service'
import {mapGetters} from 'vuex'
import {IvrSettlementVariant} from "@/constants/IvrSettlementVariant";
export default {
    name: "Update",
    components: {
        'main-content': mainContent,
        'ivr-form': IVRForm
    },
    computed: {
        ...mapGetters('ivr', [
            'form_data', 'status'
        ])
    },
    props: ['hashid'],
    data() {
        return {
            IvrSettlementVariant
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.dispatch('ivr/find', vm.hashid)
        })
    },
    methods: {
        submit(e) {
            // this.form_data.merchant_share_percent = $('#merchant_wage').val()
            // this.form_data.merchant_share_percent = 100;

            let form = $('#ivr_form');
            let btn = $('#submit_btn');

            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    category_code: {
                        required: false,
                    },
                    address: {
                        required: true,
                    },
                    phone_number: {
                        required: true
                    },
                    sheba_number: {
                        required: true
                    },
                    settlement_variant: {
                        required: true,
                    },
                    wallet_hashid: {
                        required: () => {
                            return this.form_data.settlement_variant === IvrSettlementVariant.CHARGE_WALLET;
                        },
                    },
                    // merchant_share_percent: {
                    //     required: true
                    // }
                }
            });

            if (!form.valid()) {
                return;
            }

            KTApp.progress(btn);

            let params = this.$store.getters['ivr/form_data'];

            params.settlement_variant = 1;

            ivrService.update(this.hashid, params).then(response => {
                this.$store.commit('ivr/clearFormData');
                this.$router.push('/gateways')
            })
                .catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
    },

}
</script>

<style scoped>

</style>